import { useMemo, useState } from "react";
import Modal from "../../../components/Modal/Modal";

const roleLabelMap = {
  owner: "Sahip",
  manager: "Yönetici",
  member: "Üye",
};

const makeMemberKey = (user = {}, index = 0) =>
  String(user.id || user.email || user.name || `member-${index}`);

const UserModal = ({
  open,
  close,
  email,
  setEmail,
  add,
  users,
  removeUser,
  changeUserRole,
  canManageMembers,
  currentUserId,
  currentUserEmail,
}) => {
  const [busyKey, setBusyKey] = useState("");

  const managerCount = useMemo(
    () => users.filter((user) => user?.isManager).length,
    [users]
  );

  const runBusyAction = async (key, action) => {
    if (busyKey) return;
    setBusyKey(key);
    try {
      await action();
    } finally {
      setBusyKey("");
    }
  };

  const handleInvite = () =>
    runBusyAction("invite", async () => {
      await add(email);
    });

  return (
    <Modal open={open} close={close} cardClassName="member-manage-modal">
      <h2>Kullanıcı Yönetimi</h2>

      <div className="member-manage-add">
        <input
          className="modal-input member-manage-input"
          placeholder="Kullanıcı e-posta"
          value={email}
          disabled={!canManageMembers}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== "Enter") return;
            e.preventDefault();
            if (!canManageMembers || !String(email || "").trim() || busyKey) return;
            handleInvite();
          }}
        />
        <button
          className="modal-add-button member-manage-submit"
          disabled={!canManageMembers || !String(email || "").trim() || !!busyKey}
          onClick={handleInvite}
        >
          Ekle
        </button>
      </div>

      <p className="member-manage-note">
        {canManageMembers
          ? "Yöneticileri belirleyebilir ve kullanıcıları projeden çıkarabilirsiniz."
          : "Bu listedeki kullanıcıları görebilirsiniz. Yönetici yetkisi olan kişiler rol değiştirip kullanıcı çıkarabilir."}
      </p>

      <div className="member-manage-list">
        {users.map((user, index) => {
          const key = makeMemberKey(user, index);
          const isSelfById =
            currentUserId && String(user.id || "").trim() === String(currentUserId).trim();
          const isSelfByEmail =
            currentUserEmail &&
            String(user.email || "").trim().toLowerCase() ===
              String(currentUserEmail).trim().toLowerCase();
          const isCurrentUser = !!(isSelfById || isSelfByEmail);
          const isProtectedManager = user.isManager && managerCount <= 1;
          const canToggleRole =
            canManageMembers &&
            !isCurrentUser &&
            !user.isOwner &&
            !!user.id &&
            (!user.isManager || !isProtectedManager);
          const canRemoveUser =
            canManageMembers &&
            !isCurrentUser &&
            !user.isOwner &&
            !!user.id &&
            !isProtectedManager;
          const nextRole = user.isManager ? "member" : "manager";
          const roleLabel = roleLabelMap[user.role] || roleLabelMap.member;
          const actionLabel = user.isManager ? "Yöneticiliği Al" : "Yönetici Yap";

          return (
            <article className="member-card" key={key}>
              <div className="member-card-main">
                <div className="member-card-head">
                  <strong>{user.name || "İsimsiz kullanıcı"}</strong>
                  <div className="member-card-badges">
                    <span className={`member-role-badge ${user.role || "member"}`}>
                      {roleLabel}
                    </span>
                    {isCurrentUser ? <span className="member-self-badge">Sen</span> : null}
                  </div>
                </div>
                <div className="member-card-meta">
                  {user.email || "E-posta bilgisi yok"}
                </div>
              </div>

              <div className="member-card-actions">
                {canToggleRole ? (
                  <button
                    className="member-action-button"
                    disabled={!!busyKey}
                    onClick={() =>
                      runBusyAction(`role:${key}`, async () => {
                        await changeUserRole(user, nextRole);
                      })
                    }
                  >
                    {actionLabel}
                  </button>
                ) : null}

                {canRemoveUser ? (
                  <button
                    className="member-action-button danger"
                    disabled={!!busyKey}
                    onClick={() =>
                      runBusyAction(`remove:${key}`, async () => {
                        await removeUser(user);
                      })
                    }
                  >
                    Çıkar
                  </button>
                ) : null}
              </div>
            </article>
          );
        })}

        {!users.length ? (
          <div className="member-empty-state">Projede henüz kullanıcı bulunmuyor.</div>
        ) : null}
      </div>

      <div className="modal-buttons member-manage-footer">
        <button className="modal-close-button" onClick={close}>
          Kapat
        </button>
      </div>
    </Modal>
  );
};

export default UserModal;
